import React from 'react';
import { Link } from 'react-router-dom';
import './userSelection.css'

const UserSelection = ({ userType }) => {
  return (
    <div  className={`user-selection__container ${userType}`}>
        <Link to={`/${userType}/entrar`}><h2>Entrar</h2></Link>
        <Link to={`/${userType}/crear`}><h2>Crear</h2></Link>

    </div>
  );
};

export default UserSelection;
